import React, {Component} from 'react';
import RestartButton from './restart-button';

export default class AboveGame extends Component {
    render() {
        return (
            <div className="above-game">
                <p className="game-intro">Соединяйте кубики до получения <strong>значения 2048!</strong></p>
                <RestartButton></RestartButton>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/web/above-game/index.jsx